import request from "../request";

export const getAdmissionsLimit = async () => {
  try {
    const response = await request.post("/finance/get-admissions-limit");
    return response.status === 200 && response.data ? response.data : { isCustomer: false };
  } catch (error) {
    return { isCustomer: false };
  }
};
